<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="save"
                 @close="$emit('close')"
    >
        <Invira-roles-form ref="form" v-model="form" :input-errors="inputErrors" :permissions="permissions" :roles="roles"></Invira-roles-form>

    </crud-create>
</template>

<script>
    import InviraRoleProvider from "../../../providers/InviraRoleProvider";
    import { CrudCreate } from '@dracul/common-frontend'
    import { ClientError } from "../../../../../errors";
    import InviraRolesForm from '../InviraRolesForm'

    export default {
        name: "InviraRolesCopy",
        components: {CrudCreate, InviraRolesForm},
        props: {
            role: Object,
            open: {type: Boolean, default: true},
            permissions: {
                type: Array,
                default: () => []
            },
            roles: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                title: "admin.inviraRole.creating",
                errorMessage: "",
                inputErrors: {},
                loading: false,
                form: {
                    name: this.role.name + "-2",
                    childRoles: this.role.childRoles ? (Array.isArray(this.role.childRoles) ? this.role.childRoles.map(r => (typeof r === 'object' ? r.id : r)) : []) : [],
                    permissions: this.role.permissions || []
                }

            };
        },
        watch: {
            role: {
                handler(newVal) {
                    if (newVal && newVal.id) {
                        this.form = {
                            name: newVal.name + "-2",
                            childRoles: newVal.childRoles ? (Array.isArray(newVal.childRoles) ? newVal.childRoles.map(r => (typeof r === 'object' ? r.id : r)) : []) : [],
                            permissions: newVal.permissions || []
                        }
                    }
                },
                immediate: true
            }
        },
        methods: {
            save() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    InviraRoleProvider.roleCreate(this.form)
                        .then(r => {
                            if (r) {
                                this.$emit("roleCopied", r.data.adminInviraRoleCreate)
                                this.$emit("close")
                            }
                        })
                        .catch(error => {
                            let clientError = new ClientError(error);
                            this.inputErrors = clientError.inputErrors
                            this.errorMessage = clientError.i18nMessage
                        }).finally(() => this.loading = false)
                }
            },
        }
    };
</script>

<style scoped>
</style>

